import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ContactPage from './pages/contact';
import SuccessPage from 'pages/Success';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<ContactPage />} />
        <Route path='/success' element={<SuccessPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router;